import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import BundleTypeItem from '@/components/BundleTypeItem.vue';
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import 'hooper/dist/hooper.css';
let BundleTypes = class BundleTypes extends Mixins(ViewportSizeMixin) {
    get currentBundleTypes() {
        return [
            {
                title: 'Set up your store',
                description: `Online shopping for clothes, household items, or even
                      running grocery errands online`,
                src: require('@/assets/images/icon-online-store.svg'),
            },
            {
                title: 'Food / Retail',
                description: `With the increase in demand for essential goods, taking food orders online 
                      for delivery is already the norm. Equip your food business with the right
                      tools to meet the demands of your customers.`,
                src: require('@/assets/images/icon-retail.svg'),
            },
            {
                title: 'Inquiry Bundle',
                description: `Automated your lead generation by using powerful onboarding process and
                      contact form inside Messenger.`,
                src: require('@/assets/images/icon-inquiry-bundle.svg'),
            },
        ];
    }
    get upcomingBundleTypes() {
        return [
            {
                title: 'Appointment / Booking',
                description: 'Coming Soon! Contact us if you are interested.',
                src: require('@/assets/images/icon-booking.svg'),
            },
            {
                title: 'Loan Services',
                description: 'Coming Soon! Contact us if you are interested.',
                src: require('@/assets/images/icon-loans.svg'),
            },
            {
                title: 'Event Ticketing Services',
                description: 'Coming Soon! Contact us if you are interested.',
                src: require('@/assets/images/icon-event-ticketing.svg'),
            },
        ];
    }
};
BundleTypes = __decorate([
    Component({
        components: {
            Hooper,
            Slide,
            HooperPagination,
            BundleTypeItem,
        },
    })
], BundleTypes);
export default BundleTypes;
